<template>
  <div>
    <el-input
      v-if="showKeyWord"
      v-model="keyWord"
      @change="handTagInput"
      style="width:200px;margin-right:10px"
    ></el-input>
    <el-tag
      v-for="(tag ,index) in selectedTags"
      :key="index"
      class="singleTag"
      style="margin-right: 10px"
      :closable="!disabled"
      @close="handleCloseTag(tag)"
    >{{ tag }}</el-tag>
    <el-button
      :type="!showKeyWord ? '' :'success'"
      plain
      size="small"
      :icon="!showKeyWord ? 'el-icon-plus' : 'el-icon-check'"
      @click="handShowInput"
    ></el-button>
  </div>
</template>

<script>
export default {
  props: {
    tagsList: { type: Array, default: () => [] },
    tip: { type: String, default: '' },
    disabled: { type: Boolean, default: false }
  },
  data () {
    return {
      value: '',
      keyWord: '',
      selectedTags: [],
      showKeyWord: false
    }
  },
  computed: {
    tagsListLength () {
      return this.tagsList.length
    }
  },
  watch: {
    tagsList (val) {
      if (val !== this.selectedTags) {
        this.selectedTags = val
        this.showKeyWord = false
      }
    },
    disabled (val) {
      if (val) {
        // this.showKeyWord = false
      }
    },
    tagsListLength: {
      handler (newVal) {
        if (newVal === 0) {
          this.selectedTags = []
          this.showKeyWord = false
        }
      }
    },
    immediate: false,
    deep: true
  },
  mounted () {
    this.showKeyWord = false
  },
  methods: {
    handTagInput (e) {
      let findData = this.selectedTags.find(item => item === e)
      if (findData === undefined) {
        this.selectedTags.push(e)
        this.keyWord = ''
        // this.showKeyWord = false
        this.$emit('change', this.selectedTags)
      } else {
        this.$message.error('标签重复了')
      }
    },
    handleCloseTag (tag) {
      this.selectedTags = this.selectedTags.filter(
        item => item !== tag
      )
      this.$emit('change', this.selectedTags)
    },
    handShowInput () {
      this.showKeyWord = !this.showKeyWord
    }
  }
}
</script>

<style scoped lang="less">
</style>
